import styled from 'styled-components'

export const Checkbox = styled.input({
  width: '18px',
  height: '18px',
  border: '1px solid #D7D7D7',
})
